// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import { SidebarSection } from 'bench-internal-theme';
import styled from 'styled-components';

const ThumbnailImageLayout = styled.div`
  margin-top: -24px;

  img {
    border: 1px solid ${colors.clay};
    border-radius: 4px;
    display: block;
    max-width: 100%;

    // The following styles show an error message in place of the image if it fails to load
    line-height: 64px;
    overflow: hidden;
    position: relative;
    white-space: nowrap;

    &::after {
      align-items: center;
      background: ${colors.pearl};
      border: 1px solid ${colors.clay};
      border-radius: 4px;
      bottom: -1px;
      color: ${colors.dust};
      content: 'Failed to load ' attr(alt);
      display: flex;
      font-size: 14px;
      justify-content: center;
      left: -1px;
      line-height: 16px;
      padding: 0 16px;
      position: absolute;
      right: -1px;
      text-align: center;
      top: -1px;
      white-space: normal;
    }
  }
`;

type ThumbnailImageProps = {
  alt: string,
  src: string,
};

const ThumbnailImage = ({ alt, src }: ThumbnailImageProps) => (
  <SidebarSection>
    <ThumbnailImageLayout>
      <img alt={alt} src={src} />
    </ThumbnailImageLayout>
  </SidebarSection>
);

export default ThumbnailImage;
